import React, { useState } from "react";
import { Html } from "react-konva-utils";



const TextoEditable = (props) => {

    const {
        id,
        x,
        y,
        width,
        height,
        text,
        setIsEditing,
        setNodos,
        nodos
    } = props;
      
    const onKeyDown = (e)=>{
        if(e.key === 'Enter'){
            setIsEditing(false);
        }
    }
    
    const [textoComponente, setTextoComponente] = useState(text);

    let textoFinal = '';

    const handleChange = (e) =>{
        textoFinal=e.target.value;
        setTextoComponente(e.target.value);
        setNodos(
            nodos.map((nodo)=>{
                if(id === nodo.id){
                    return {
                        ...nodo,
                        isDragging: false,
                        text: textoFinal
                    }
                }else{
                    return {
                        ...nodo,
                        isDragging: false,
                    }
                }
            })
        )
    }

    return (
        <Html groupProps={{ x, y }} divProps={{ style: { opacity: 1 } }}>
          <textarea
            value={textoComponente}
            onChange={handleChange}
            onKeyDown={onKeyDown}
            onMouseLeave={()=>{setIsEditing(false)}}
            style={{
                width: `${width}px`,
                height: `${height}px`,
                border: "none",
                padding: "0px",
                margin: "0px",
                background: "white",
                outline: "none",
                resize: "none",
                colour: "black",
                fontSize: "19px",
                fontFamily: "Arial"
            }}
          />
        </Html>
    );
}

export default TextoEditable
